/*eslint-disable eqeqeq*/
import React from "react";
import * as APIController from '../../../../../api/APIController.js';
import Table from "../../../../../shared/components/table/table";
import TableHead from "../../../../../shared/components/table/tableHead";
import TableRow from "../../../../../shared/components/table/tableRow";
import TableBody from "../../../../../shared/components/table/tableBody";
import TableCell from "../../../../../shared/components/table/tableCell";
import double_left_arrow from '../../../../../assets/images/left-doble-arow.svg';
import left_arrow from '../../../../../assets/images/left-arrow.svg';
import double_right_arrow from '../../../../../assets/images/right-doble-arow.svg';
import right_arrow from '../../../../../assets/images/right-arrow.svg';
import "react-perfect-scrollbar/dist/css/styles.css";

import PerfectScrollbar from "react-perfect-scrollbar";

import deleteIcon from '../../../../../assets/images/delete.svg'
import editIcon from '../../../../../assets/images/edit.svg'
import filtericon from '../../../../../assets/images/ic_feather_filter.svg'
import ConfirmtionDialog from '../../../../ConfirmDialog/ConfirmationDialog';
import Notification from '../../../../../shared/components/notification/notification';
import Modal from '../../../../../shared/components/modal/modal';
import CircularProgress from "../../../../../shared/components/CircularProgress/CircularProgress";
import PageTitle from "../../../../../config/pageTitle";

const ConfigurationList = (props) => {

	const headerList = ['action', "Segment", "Brand", "Lenses Type", "Purchase Type", "Price", "Minimum Quantity"]
	const { currentPage,
		count,
		rowsPerPage,
		rowsPerPageOptions,
		list, to, from } = props;
	let lensestypeList = list;

	const [LoginDialog, setLoginDialog] = React.useState(false);
	const [DeleteId, setDeleteId] = React.useState('');

	// MinimumQuantityForAnnualSupply, PurchaseType, Segment, Brand, LenseType

	const [Segment, setSegment] = React.useState('');
	const [BrandName, setBrandName] = React.useState('');
	const [LenseType, setLenseType] = React.useState('');
	const [PurchaseType, setPurchaseType] = React.useState('');
	const [Price, setPrice] = React.useState('');
	const [MinimumQuantity, setMinimumQuantity] = React.useState('');

	const page = rowsPerPage == 1000000 ? 1 : Math.floor(count / rowsPerPage) + 1;
	// const page = Math.floor(count / rowsPerPage) + 1;

	const handleChangeInCurrentPage = (value) => {
		if (value <= page && Number(parseInt(value))) {
			props.handleChangePage(Number(value), MinimumQuantity, PurchaseType, Segment, BrandName, LenseType);
		}
	}

	const wsDeleteConfiguration = (ID) => {
		APIController.DeleteConfiguration(ID)
			.then((response) => {
				if (response.error == null) {
					if (response.object.status == 1) {
						handleNotification(response.object.message);
					} else {
						handleNotification(response.object.message, true);
					}
					props.handlebind()
					setLoginDialog(false)
				}
				else if (response.error.message && response.error.message.length > 0) {
					handleNotification(response.error.message, true);
				}
			})
	}

	const [message, setMessage] = React.useState("");
	const [showNotification, setShowNotification] = React.useState(false);
	const [isError, setIsError] = React.useState(false);

	const handleNotification = (message, isError) => {
		setMessage(message)
		setShowNotification(true)
		setIsError(isError)

		setTimeout(() => {
			handleClearNotification();
		}, 4000)
	}

	const handleClearNotification = () => {
		setMessage('')
		setShowNotification(false)
		setIsError(false)
	}

	const _handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			props.applyFilter(MinimumQuantity, PurchaseType, Segment, BrandName, LenseType)
		}
	}

	return (
		<>
			<h1><PageTitle Title="View Configuration" /></h1>
			<div className="table-main-wrap">
				<PerfectScrollbar component='div'>
					<Table className="">
						<TableHead>
							<TableRow>
								{headerList.map((obj, index) => { return <TableCell style={index == 0 ? { width: '5%' } : headerList.length - 1 == index ? { width: '20%' } : { width: '18.5%' }} className={obj === "Is active ?" ? 'center' : ''} key={index}>{obj}</TableCell>; })}
							</TableRow>
							<TableRow>
								<TableCell style={{ width: '5%' }}> <span><img src={filtericon} alt="delete" /></span> </TableCell>
								<TableCell style={{ width: '25%' }}> <input type="text" name="" placeholder="Name" onKeyDown={_handleKeyDown} onChange={(e) => setSegment(e.target.value)} /> </TableCell>
								<TableCell style={{ width: '25%' }}> <input type="text" name="" placeholder="Brand" onKeyDown={_handleKeyDown} onChange={(e) => setBrandName(e.target.value)} /> </TableCell>
								<TableCell style={{ width: '18%' }}> <input type="text" name="" placeholder="Lense Type" onKeyDown={_handleKeyDown} onChange={(e) => setLenseType(e.target.value)} /> </TableCell>
								<TableCell style={{ width: '18%' }}> <input type="text" name="" placeholder="Purchase Type" onKeyDown={_handleKeyDown} onChange={(e) => setPurchaseType(e.target.value)} /> </TableCell>
								<TableCell style={{ width: '18%' }}> </TableCell>
								<TableCell style={{ width: '18%' }}> <input type="text" name="" placeholder="Minimum Quantity" onKeyDown={_handleKeyDown} onChange={(e) => setMinimumQuantity(e.target.value)} /> </TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{!!lensestypeList.length ? lensestypeList.map((obj, idnex) => {
								return (
									<TableRow key={idnex}>
										<TableCell style={{ width: '5%' }}>
											<span>
												<img src={editIcon} alt="edit" style={{ cursor: 'pointer', marginRight: '3px' }}
													onClick={() => {
														props.history.push({
															pathname: '/supplytool/configuration/add',
															state: { typeIdEdit: obj.ID }
														})
													}} />
												<img src={deleteIcon} alt="delete" style={{ cursor: 'pointer', marginRight: '3px' }}
													onClick={() => {
														setDeleteId(obj.ID)
														setLoginDialog(true)
													}} />
											</span>
										</TableCell>
										<TableCell style={{ width: '25%' }}> {obj.Segment} </TableCell>
										<TableCell style={{ width: '25%' }}> {obj.Brand} </TableCell>
										<TableCell style={{ width: '18%' }}> {obj.LenseType} </TableCell>
										<TableCell style={{ width: '18%' }}> {obj.PurchaseType} </TableCell>
										<TableCell style={{ width: '18%' }}> {obj.Price} </TableCell>
										<TableCell style={{ width: '18%' }}> {obj.MinimumQuantityForAnnualSupply} </TableCell>
									</TableRow>
								);
							}) : <TableRow>
								<TableCell colSpan={headerList.length} className="not_found">
									{props.progress ? <CircularProgress /> : <label>Not Currently Available</label>}
								</TableCell>
							</TableRow>}
						</TableBody>
					</Table>
				</PerfectScrollbar>
			</div>
			<Notification
				isError={isError}
				message={message}
				showNotification={showNotification}
				clearNotification={handleClearNotification.bind(this)}
				closeNotification={handleClearNotification.bind(this)}
			/>
			{LoginDialog && (
				<Modal
					show={LoginDialog}
					handleClose={() => setLoginDialog(false)}>
					<ConfirmtionDialog
						title={"Delete Configuration"}
						description={"Are you sure you want to delete this Configuration ?"}
						deletePress={() => wsDeleteConfiguration(DeleteId)}
						closeModal={() => setLoginDialog(false)}
					/>
				</Modal>
			)}
			<div className="table-pagination">
				<div className="pagination-info">
					<p>Showing {from + 1} - {to > count ? count : to} of {count}</p>
				</div>
				<div className="pagination-control">
					<a href="#!" title="" className={`double-left-arrow ${props.currentPage == 1 ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(1)
						}}
					><img src={double_left_arrow} alt="left" /></a>
					<a href="#!" title="" className={`simple-left-arrow ${props.currentPage == 1 ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(currentPage - 1)
						}}
					><img src={left_arrow} alt="single_left" /></a>
					<span>Page</span>
					<input disabled type="text" name="textbox" value={currentPage === 0 ? currentPage + 1 : currentPage} onChange={(e) => handleChangeInCurrentPage(e.target.value)} />
					<span>of {page}</span>
					<a href="#!" title="" className={`simple-right-arrow ${currentPage == page ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(currentPage + 1)
						}}
					><img src={right_arrow} alt="right" /></a>
					<a href="#!" title="" className={`double-right-arrow ${currentPage == page ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(page)
						}}><img src={double_right_arrow} alt="single_right" /></a>
					<select onChange={(e) => props.handleChangeRowsPerPage(parseInt(e.target.value), MinimumQuantity, PurchaseType, Segment, BrandName, LenseType)} defaultValue={rowsPerPage}>
						{
							rowsPerPageOptions.map((obj, index) => {
								return <option value={obj} key={index}>{obj}</option>
							})
						}
					</select>
				</div>
			</div>
		</>
	);
};

export default ConfigurationList;
